// Accounting Income Types Vuex

import state from './payrollDetailStates.js'
import * as getters from './payrollDetailGetters.js'
import * as mutations from './payrollDetailMutations.js'
import * as actions from './payrollDetailActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
